import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Text,
  Box,
  VStack,
  useBreakpointValue,
  Input,
  IconButton,
  InputGroup,
  InputRightElement,
  Spinner,
} from '@chakra-ui/react';
import { CopyIcon } from '@chakra-ui/icons';
import { generateAffiliateLink } from '../utils/affiliate';
import { useTranslation } from 'react-i18next';
import { useAuth } from "../context/AuthProvider";
import { firestore, doc, getDoc, collection, query, where, getDocs } from "../firebase/firebaseConfig";

const AffiliateDashboard = ({ userId }) => {
  const { t } = useTranslation();
  const [link, setLink] = useState('');
  const { user } = useAuth();
  const [referralCode, setReferralCode] = useState("");
  const isMobile = useBreakpointValue({ base: true, md: false });
  const linkInputRef = useRef(null);
  const referralCodeInputRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [usedCount, setUsedCount] = useState(0);


  useEffect(() => {
    if (user) {
      const fetchReferralData = async () => {
        try {
          const userRef = doc(firestore, "users", user.uid);
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            const code = userSnap.data().referralCode || "N/A";
            setReferralCode(code);

            // 🔥 Query Firestore to count users who used this referral code
            const referredUsersQuery = query(collection(firestore, "users"), where("referredByCode", "==", code));
            const referredUsersSnap = await getDocs(referredUsersQuery);

            setUsedCount(referredUsersSnap.size);
          }
        } catch (error) {
          console.error("❌ Error fetching referral data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchReferralData();
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      const fetchReferralCode = async () => {
        const userRef = doc(firestore, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          setReferralCode(userSnap.data().referralCode || "N/A");
        }
      };
      fetchReferralCode();
    }
  }, [user]);

  const handleGenerateLink = () => {
    const affiliateLink = generateAffiliateLink(userId);
    setLink(affiliateLink);
  };

  const handleCopyLink = () => {
    if (linkInputRef.current) {
      linkInputRef.current.select();
      document.execCommand('copy');
    }
  };

  const handleCopyReferralCode = () => {
    if (referralCodeInputRef.current) {
      referralCodeInputRef.current.select();
      document.execCommand('copy');
    }
  };

  return (
    <Box
      align="stretch"
      maxW="container.md"
    >
      {/* <Button
        colorScheme="green"
        onClick={handleGenerateLink}
      >
        {t("affiliatedashboard.generate_link")}
      </Button>
      {link && (
        <Box mt={2}>
          <Text fontSize={isMobile ? "sm" : "md"}>
            {t("affiliatedashboard.your_link")}:
          </Text>
          <InputGroup>
            <Input
              ref={linkInputRef}
              value={link}
              isReadOnly
              fontSize={isMobile ? "sm" : "md"}
              mr={20}
            />
            <InputRightElement width="4.5rem">
              <IconButton
                aria-label="Copy Link"
                icon={<CopyIcon />}
                onClick={handleCopyLink}
              />
            </InputRightElement>
          </InputGroup>
        </Box>
      )} */}
      <VStack spacing={3} align="stretch" mt={4}>

         {/* 🔥 Display the number of users who used the referral code */}
         {loading ? (
          <Spinner size="sm" mt={2} />
        ) : (
          <Text fontSize="sm" color="gray.500">
            {usedCount} user(s) have signed up using your referral code.
          </Text>
        )}

        <Text fontSize={isMobile ? "sm" : "md"}>
          Your Referral Code:
        </Text>
        <InputGroup>
          <Input
            ref={referralCodeInputRef}
            value={referralCode}
            isReadOnly
            fontSize={isMobile ? "sm" : "md"}
            mr={20}
          />
          <InputRightElement width="4.5rem">
            <IconButton
              aria-label="Copy Referral Code"
              icon={<CopyIcon />}
              onClick={handleCopyReferralCode}
            />
          </InputRightElement>
        </InputGroup>
      </VStack>
    </Box>
  );
};

export default AffiliateDashboard;